<template>
  <div class="mt-2 mt-lg-2">
    <div class="h-100 p-3 bg-white box-shadow text-center">
      <span
        ><i class="fas fa-info-circle"></i> Images saved or edited in this tool
        will be synced to the website every four hours.</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Info",
};
</script> 